import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as changeImpactPersonas from '../../change-impact-personas'

export const RESOURCE = {
  payload: {
    description: 'Represents a link between a change impact and a persona.',
    dimension: changeImpactPersonas.RESOURCE.payload,
    level: 0,
    name: 'Change Impact Persona',
    partialId: PartialId.Standard.create('change_impact_persona'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
